<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-btn @click.stop="onAdd" color="primary" outline>
              <i class="material-icons">add</i>
              {{ $t('message.addNew')}}
            </v-btn>
            <v-spacer></v-spacer>

            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table :headers="headers" :items="linkedCompanies" :search="search">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.company.name }}</td>
              <td class="text-center">{{ `${props.item.pendingToPayStore} $` }}</td>
              <td class="text-center">{{ `${props.item.pendingToPayDelivery} $` }}</td>
              <td class="text-center">
                <v-chip
                  v-if="props.item.allow_payment_to_delivery"
                  color="light-green accent-4"
                  outline
                >{{ $t('message.enabled') }}</v-chip>

                <v-chip v-else outline color="error">{{ $t('message.disabled') }}</v-chip>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <v-btn
                    @click="onView(props.item)"
                    slot="activator"
                    color="primary"
                    outline
                    fab
                    icon
                    small
                  >
                    <v-icon class="zmdi zmdi-search"></v-icon>
                  </v-btn>
                  <span>{{ $t('message.details') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    @click="onDelete(props.item)"
                    color="error"
                    outline
                    fab
                    icon
                    slot="activator"
                    small
                  >
                    <v-icon light>cancel</v-icon>
                  </v-btn>
                  <span>{{ $t('message.delete') }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>

          <manage-delivery-company
            :dialog.sync="showModal"
            :isEdit="isEdit"
            :isCreate="isCreate"
            :isView="isView"
            @on-save="onSave"
            ref="ManageElementModal"
          ></manage-delivery-company>

          <delete-confirmation-dialog
            @onConfirm="deleteElement"
            :heading="$t('message.deleteConfirmation')"
            :message="$t('message.deleteMessage')"
            ref="deleteConfirmationDialog"
          ></delete-confirmation-dialog>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_LINKED_COMPANIES,
  LINK_DELIVERY_COMPANY,
  UNLINK_DELIVERY_COMPANY
} from "../../../store/modules/delivery/store/actions.type";

import ManageDeliveryCompany from "../admin/ManageDeliveryCompany";

export default {
  name: "deliveryCompaniesList",
  components: {
    ManageDeliveryCompany
  },
  data() {
    return {
      headers: [
        { text: "name", sortable: false, value: "company.name" },
        { text: "pendingToCharge", sortable: false, align: "center", value: "pendingToPayStore" },
        { text: "pendingToPay", sortable: false, align: "center", value: "pendingToPayDelivery" },
        {
          text: "permissionToCharge",
          sortable: false,
          value: "allow_payment_to_delivery",
          align: "center"
        },
        { text: "actions", sortable: false, value: "", align: "center" }
      ],
      search: "",
      selectedElement: {},
      showModal: false,
      isCreate: false,
      isEdit: false,
      isView: false,
    };
  },
  created() {
    this.getLinkedCompanies();
  },
  computed: {
    ...mapGetters(["linkedCompanies"])
  },
  methods: {
    getLinkedCompanies() {
      this.$store.dispatch(GET_LINKED_COMPANIES);
    },
    onAdd() {
      this.isCreate = true;
      this.isEdit = false;
      this.isView = false;
      
      this.showModal = true;
    },
    onView(element) {
      this.isCreate = false;
      this.isView = true;
      this.isEdit = false;

      this.selectedElement = element;
      this.$refs.ManageElementModal.setValue(element);

      this.showModal = true;
    },
    onEdit(element) {
      this.isCreate = false;
      this.isEdit = true;
      this.isView = false;

      this.selectedElement = element;
      this.$refs.ManageElementModal.setValue(element);
      
      this.showModal = true;
    },
    onDelete(element) {
      this.selectedElement = element;
      this.$refs.deleteConfirmationDialog.openDialog();
    },
    deleteElement() {
      this.$store.dispatch(
        UNLINK_DELIVERY_COMPANY,
        this.selectedElement.company.id
      );
      this.$refs.deleteConfirmationDialog.close();
    },
    async onSave(data) {
      if (this.isCreate) {
        
        await this.$store.dispatch(LINK_DELIVERY_COMPANY, data);
      } else {
        //this.selectedDealer = Object.assign({}, this.selectedDealer, element);
        //await this.$store.dispatch(UPDATE_DELIVERY_DEALER, this.selectedDealer);
      }

      this.$refs.ManageElementModal.resetForm();
    }
  }
};
</script>

<style>
</style>